import { render, staticRenderFns } from "./ActiveCard.vue?vue&type=template&id=4793fa54&"
import script from "./ActiveCard.vue?vue&type=script&lang=js&"
export * from "./ActiveCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports